<script>
  import { STREAM_TYPE_VOD } from '../js/constants.js';
  import {
    STREAM_COUNTDOWN_MOMENTARILY,
    STREAM_WILL_BEGIN_IN,
    VOD_COUNTDOWN_MOMENTARILY,
    VOD_WILL_BEGIN_IN,
    COUNTDOWN_DAYS,
    COUNTDOWN_HOURS,
    COUNTDOWN_MINUTES,
    COUNTDOWN_SECONDS,
  } from '../js/l10n/en_US.js';
  import DownloadZoom from './DownloadZoom.svelte';
  import { STREAM_EXTERNAL_SOURCE_TYPE_ZOOM } from '../js/constants.js';
  import { eventState, streamState } from '../js/state.js';

  import * as moment from 'moment';
  export let date = false;
  let days = '-',
    hours = '-',
    minutes = '-',
    seconds = '-',
    diff;
  const sid = 24 * 60 * 60,
    sih = 60 * 60,
    sim = 60;

  setInterval(calculateDiff, 1000);

  function calculateDiff() {
    if (!date) return;
    let future = moment(date);
    diff = future.diff(moment()) / 1000;
    days = Math.floor(diff / sid);
    hours = Math.floor((diff % sid) / sih);
    minutes = Math.floor((diff % sih) / sim);
    seconds = Math.floor(diff % sim);
  }
</script>

<div class="player-banner player-banner-dark">
  {#if diff <= 0}
    {$streamState.type === STREAM_TYPE_VOD ? VOD_COUNTDOWN_MOMENTARILY : STREAM_COUNTDOWN_MOMENTARILY}
  {:else}
    {#if !$eventState.player_hide_countdown}
      {$streamState.type === STREAM_TYPE_VOD ? VOD_WILL_BEGIN_IN : STREAM_WILL_BEGIN_IN}
      <div class="clock">
        <div class="digit-wrap">
          <div class="digit">
            <span>{days}</span>
            {COUNTDOWN_DAYS}
          </div>
          <div class="digit">
            <span>{hours}</span>
            {COUNTDOWN_HOURS}
          </div>
          <div class="digit">
            <span>{minutes}</span>
            {COUNTDOWN_MINUTES}
          </div>
          <div class="digit">
            <span>{seconds}</span>
            {COUNTDOWN_SECONDS}
          </div>
        </div>
      </div>
    {/if}
    {#if $eventState.player_msg_pre}
      <div class="player-msg-pre">{$eventState.player_msg_pre}</div>
    {/if}
    {#if $streamState.external_source_type === STREAM_EXTERNAL_SOURCE_TYPE_ZOOM}
      <DownloadZoom />
    {/if}
  {/if}
</div>
